var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugLog } from "./debugLog";
import { sendToGame } from "./sendToGame";
import { verifyEvent } from "./verifyEvents/verifyEvent";
const intercepts = new Map();
const subs = new Map();
export const publishToModules = (event, payload, source) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const stoppedByIntercept = (_a = intercepts.get(event)) === null || _a === void 0 ? void 0 : _a.reduce((prev, interceptor) => {
        const interceptResult = interceptor(payload);
        const stopAfterIntercepts = interceptResult.stopEvent || prev;
        if (interceptResult.newPayload !== undefined) {
            payload = interceptResult.newPayload;
        }
        return stopAfterIntercepts;
    }, false);
    if (stoppedByIntercept === true) {
        return { verified: false };
    }
    const canSend = yield verifyEvent(event, payload, source);
    if (canSend.includes(false)) {
        return { verified: false };
    }
    if (event === "nx-message") {
        debugLog(event, payload.data);
    }
    else if (event === "game-load-progress") {
    }
    else {
        debugLog(event, payload);
    }
    (_b = subs.get(event)) === null || _b === void 0 ? void 0 : _b.forEach((listener) => {
        try {
            listener(payload);
        }
        catch (error) {
            console.warn(`'${event}' listener in a module threw an error:`);
            console.error(error);
        }
    });
    return { verified: true, payload };
});
export const publish = (event, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield publishToModules(event, payload);
    if (result.verified && !event.startsWith("nx")) {
        sendToGame(event, result.payload);
    }
});
export const subscribe = (event, listener) => {
    const listeners = subs.get(event);
    if (listeners === undefined) {
        subs.set(event, [listener]);
    }
    else if (listeners.indexOf(listener) === -1) {
        listeners.push(listener);
    }
};
const removeListenersForCallback = (listenerToRemove) => {
    subs.forEach((listenersArray, key) => {
        for (let i = listenersArray.length - 1; i >= 0; i--) {
            if (listenersArray[i] === listenerToRemove) {
                listenersArray.splice(i, 1);
                debugLog("Removed a listener for", key);
            }
        }
    });
};
export const unsubscribe = (listenerToRemove) => {
    setTimeout(() => {
        removeListenersForCallback(listenerToRemove);
    }, 0);
};
export const intercept = (event, interceptingListener) => {
    const interceptListeners = intercepts.get(event);
    if (interceptListeners === undefined) {
        intercepts.set(event, [interceptingListener]);
    }
    else if (!interceptListeners.includes(interceptingListener)) {
        interceptListeners.push(interceptingListener);
    }
};
export const clearIntercept = (listenerToRemove) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        setTimeout(() => {
            intercepts.forEach((listenersArray) => {
                for (let i = listenersArray.length - 1; i >= 0; i--) {
                    if (listenersArray[i] === listenerToRemove) {
                        listenersArray.splice(i, 1);
                    }
                }
            });
            resolve();
        }, 0);
    });
});
